export default __webpack_public_path__ + "static/media/email.8704112c.svg";